<!-- eslint-disable no-unused-vars -->
<script setup>
import { computed } from 'vue';
// Import Library และ CSS
import { VueImageZoomer } from 'vue-image-zoomer';
import 'vue-image-zoomer/dist/style.css';
import moment from 'moment'
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";

const props = defineProps({
  workcaseDetail: { type: Object, default: null },
  images: { type: Array, default: () => [] },
  listinfo: { type: Array, default: () => [] },
  paymentE: { type: Object, default: null },
  paymentL: { type: Array, default: () => [] },
  promotionDetail: { type: Object, default: null },
  depRef: { type: String, default: '' },
  tkStatus: { type: String, default: '' },
  intCal: { type: [Number, String], default: 0 },
  intPeriod: { type: [Number, String], default: 0 },
  transactionLabel: { type: String, default: '' },
  history: { type: String, default: '' },
  fcusdt: { type: Boolean, default: false }, // รับค่ามาจาก Parent
  afChangename: { type: String, default: '' },
  bfChangename: { type: String, default: '' },
  transDatePrv: { type: Date, default: null },
});

// กำหนด emit สำหรับอัปเดตค่า v-model
const emit = defineEmits(['update:fcusdt', 'copy', 'openHistory']);

// --- Helpers ---
function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  } else if (str === 'REVIEW_COLLATERAL') {
    side = 'ขอดูทรัพย์'
  }
  return side
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

</script>

<template>
  <div id="lookupModal2" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width: 1240px;">
      <div class="modal-content border-0 shadow-lg" v-if="workcaseDetail">
        <div class="modal-header align-items-center">
          <h4 class="modal-title fw-bold">{{ $t("content.detail") }}</h4>
          <div style="display: flex; justify-content: flex-end">
            <div>
              <div class="d-inline-block mx-4">
              </div>
            </div>
            <div>
              <div class="d-inline-block mx-4">
              </div>
            </div>
            <div>
              <div class="d-inline-block mx-4">
                <!-- เพิ่ม v-if เช็คค่า history ตรงนี้ -->
                <material-checkbox 
                  v-if="history === 'yes'"
                  id="infocus" 
                  :modelValue="fcusdt" 
                  @update:modelValue="emit('update:fcusdt', $event)"
                >
                  {{ $t("content.infofcus") }}
                </material-checkbox>
              </div>
            </div>
          </div>
          
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <i class="material-icons material-symbols-outlined">close</i>
          </button>
        </div>

        <div class="modal-body p-4">
          <div class="row">
            <!-- ซีกซ้าย: รูปภาพ (ถ้ามี) -->
            <div class="col-lg-6 mt-2">
              <div id="lookupImages2" class="carousel slide" data-bs-ride="false" style="max-width: 520px">
  
              <!-- Indicators: แสดงจุดเมื่อมีมากกว่า 1 รูป -->
              <div class="carousel-indicators" v-if="images.length > 1">
                <button 
                  v-for="(img, idx) in images" 
                  :key="'ind-' + idx"
                  type="button" 
                  data-bs-target="#lookupImages2" 
                  :data-bs-slide-to="idx" 
                  :class="{ active: idx === 0 }"
                ></button>
              </div>

              <div class="carousel-inner rounded bg-light">
                <!-- วนลูปรูปภาพ (ห้ามมี ul/li ครอบ) -->
                <div 
                  v-for="(img, index) in images" 
                  :key="index" 
                  class="carousel-item" 
                  :class="{ active: index === 0 }"
                  style="max-height: 650px;" 
                >
                  <!-- เรียกใช้ img.src ตาม Object ที่คุณสร้าง -->
                  <VueImageZoomer 
                    :regular="img.src" 
                    img-class="d-block w-100 img-fluid" 
                    :zoom-amount="3" 
                    :click-zoom="true"
                    :alt="img.alt"
                    :title="img.title"
                    close-pos="top-right"
                    message-pos="top"
                  />
                </div>
              </div>

              <!-- ปุ่มเลื่อน: แสดงเมื่อมีมากกว่า 1 รูป -->
              <template v-if="images.length > 1">
                <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages2" data-bs-slide="prev">
                  <span class="carousel-control-prev-icon"></span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#lookupImages2" data-bs-slide="next">
                  <span class="carousel-control-next-icon"></span>
                </button>
              </template>
            </div>
            </div>

            <!-- ซีกขวา: ข้อมูลตั๋ว (อ้างอิงตามรูปตัวอย่าง) -->
            <div class="col-lg-6 mt-2">
              <div v-if="workcaseDetail !== null" style="overflow-x:auto;">
                <div>
                  <table class="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td class="fs-14 text-bold">{{ $t("content.ticketno") }} :
                          <span v-if="workcaseDetail.tkRefNumber !== ''">
                            {{ workcaseDetail.tkRefNumber }} &nbsp;
                              <i class="material-icons cursor-pointer align-middle" @click="emit('copy')">content_copy</i>
                          </span>
                          <span v-else>-</span>
                        </td>
                        <td class="fs-14 text-bold">{{ $t("content.stkeeptk") }} :
                          <span v-if="workcaseDetail.deposit" style="color:green;">
                            {{ $t("content.stdeposittk") }} ({{ depRef }})
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>

                      </tr>
                      <tr>
                        <td class="fs-14 text-bold">{{ $t("content.trans") }} :
                          {{ checkTransaction(workcaseDetail.transactionType) }}
                        </td>
                        <td class="fs-14 text-bold">{{ $t("content.statusticket") }} :
                          <span v-if="workcaseDetail.status === 'FINISH'" style="color:green;">
                            {{ tkStatus  }}
                          </span>
                          <span v-else-if="workcaseDetail.status === 'FREEZE' || workcaseDetail.status === 'TERMINATE'
                            || workcaseDetail.status === 'BREAKING'" style="color:red;">
                            <span v-if="workcaseDetail.status === 'BREAKING'">
                              {{ tkStatus  }} ({{ format_date(workcaseDetail.breakingDate) }} : {{
                                workcaseDetail.lotNumber }})
                            </span>
                            <span v-else>
                              {{ tkStatus  }}
                            </span>
                          </span>
                          <span v-else>
                            {{ tkStatus  }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="workcaseDetail.postponeCount === 0">
                        <td class="fs-14 text-bold"> {{ $t("content.lasttrf") }} : {{
                          format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                        <td class="fs-14 text-bold">
                          {{ $t("content.amnduedate") }} :
                          <span style="color:red;">
                            {{ format_date(workcaseDetail.dueDate) }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="workcaseDetail.postponeCount !== 0">
                        <td class="fs-14 text-bold" colspan="2"> {{ $t("content.lasttrf") }} : {{
                          format_datetime(workcaseDetail.workItems[0].startTime) }}</td>
                      </tr>
                      <tr v-if="workcaseDetail.postponeCount !== 0">
                        <td class="fs-14 text-bold" colspan="2">
                          {{ $t("content.amnduedate") }} :
                          <span style="color:red;">
                            {{ format_date(workcaseDetail.dueDate) }} (ขอเลื่อนเป็นวันที่ {{
                              format_date(workcaseDetail.postponeDate) }})
                          </span>
                        </td>
                      </tr>
                      <tr v-if="workcaseDetail.postponeCount !== 0">
                        <td class="fs-14 fw-bold" colspan="2">
                          {{ $t("content.deferpast") }} :
                          <span 
                            @click="emit('openHistory')" 
                            style="text-decoration: underline; color: red; cursor: pointer"
                          >
                            {{ workcaseDetail.postponeCount }}
                          </span>
                        </td>
                      </tr>
                      <template v-if="workcaseDetail.latest">
                        <tr>
                          <td class="fs-14 text-bold">
                            {{ $t("content.monthlyprofn") }} : {{
                              formatNumberDecimalString(workcaseDetail.interestPerMonth) }}
                          </td>
                          <td class="fs-14 text-bold">
                            {{ $t("content.currentprof") }} :
                            <span style="color:red;">
                              {{ formatNumberDecimalString(intCal) }} ({{ format_date(new Date()) }})
                            </span>
                          </td>
                        </tr>
                      </template> 
                      <template v-else>
                        <tr>
                          <td class="fs-14 text-bold" colspan="2">
                            {{ $t("content.monthlyprofn") }} : {{
                              formatNumberDecimalString(workcaseDetail.interestPerMonth) }}
                          </td>
                        </tr>
                      </template>
                      <tr v-if="!fcusdt || !workcaseDetail.latest">
                        <td class="fs-14 text-bold">
                            {{ $t("content.intpay") }} : 
                            <span v-if="workcaseDetail.interestRef !== null">
                                {{formatNumberDecimalString(workcaseDetail.interestRef.overdueInterest+workcaseDetail.interestRef.dueInterest)}}
                            </span>
                            <span v-else>
                                {{formatNumberDecimalString(0)}}
                            </span> 
                        </td>
                        <td class="fs-14 text-bold">
                            {{ $t("content.discount") }} :
                            <span style="color:red;">
                              <span v-if="workcaseDetail.interestRef !== null">
                                  {{ formatNumberDecimalString(workcaseDetail.interestRef.calDiscount) }}
                              </span>
                              <span v-else>
                                {{formatNumberDecimalString(0)}}
                              </span> 
                            </span>
                          </td>
                      </tr>
                      <tr  v-if="!fcusdt || !workcaseDetail.latest">
                        <td class="fs-14 text-bold" colspan="2">
                          {{ $t("content.ttintpay") }} : 
                          <span v-if="workcaseDetail.interestRef !== null">
                            {{
                            formatNumberDecimalString((workcaseDetail.interestRef.overdueInterest+workcaseDetail.interestRef.dueInterest)-workcaseDetail.interestRef.calDiscount) }}
                          </span>
                          <span v-else>
                            {{formatNumberDecimalString(0)}}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold">
                          {{ $t("content.ttprointerest") }} :
                          <span
                            v-if="workcaseDetail.interestPromotion === null || workcaseDetail.interestPromotion === 0">
                            -
                          </span>
                          <span style="color:blue;" v-else>
                            {{ formatNumberDecimalString(workcaseDetail.interestPromotion) }}
                          </span>
                        </td>
                        <td class="fs-14 text-bold">
                          {{ $t("content.periodpromotion") }} :
                          <span v-if="workcaseDetail.promotionDuration === 0">
                            -
                          </span>
                          <span style="color:blue;" v-else>
                            {{ workcaseDetail.promotionDuration }} เดือน
                          </span>
                        </td>
                      </tr>

                      <template v-if="!fcusdt && workcaseDetail.interestPromotion !== 0 && promotionDetail !== null">
                          <tr v-for="(item, index) in promotionDetail.interests" :key="item.id">
                            <div v-if="item.promotion" class="fs-14 text-bold" style="display: flex; width: 100%;">
                                <!-- คอลัมน์ซ้าย: กำหนดความกว้างคงที่เพื่อให้ย่อหน้าตรงกัน -->
                                <div style="width: 70px;">
                                  เดือนที่ {{ index + 1 }} :
                                </div>
                                <!-- คอลัมน์ขวา: แสดงตัวเลขสีน้ำเงิน -->
                                <div style="color:blue;">
                                  {{ item.interestVal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                </div>
                            </div>
                          </tr>
                      </template>
                      <tr v-if="!fcusdt">
                        <td v-if="workcaseDetail.latest" class="fs-14 text-bold">{{ $t("content.periodpawnn") }} :
                          <span style="color:blue;">
                            {{ intPeriod }} เดือน
                          </span>
                        </td>
                        <td class="fs-14 text-bold">{{ $t("content.amnbookno") }}
                          <span style="color:blue;">
                            {{ workcaseDetail.tkVolNo }}
                          </span>
                          &nbsp;{{ $t("content.amnno") }}
                          <span style="color:blue;">
                            {{ workcaseDetail.tkNo }}
                          </span>
                        </td>
                      </tr>
                      <tr v-else>
                        <td v-if="workcaseDetail.latest" class="fs-14 text-bold" colspan="2">{{ $t("content.periodpawnn") }} :
                          <span style="color:blue;">
                            {{ intPeriod }} เดือน
                          </span>
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold">{{ $t("content.amnqtypiece") }} :
                          {{ formatNumberString(workcaseDetail.ticket.totalQuantity) }}
                        </td>
                        <td class="fs-14 text-bold">{{ $t("content.allweight") }} :
                          {{ formatNumberDecimalString(workcaseDetail.ticket.totalWeight) }}
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold">{{ $t("content.pawnvalpv") }} :
                          <span v-if="workcaseDetail.transactionType === 'PAWN'">
                            {{ formatNumberDecimalString(0) }}
                          </span>
                          <span v-else>
                            {{ formatNumberDecimalString(workcaseDetail.pawnValue) }} 
                            <span style="color:red;">
                              ({{format_date(transDatePrv) }})
                            </span>
                          </span>
                        </td>
                        <td class="fs-14 text-bold">{{ $t("content.actpawn3") }}/{{ $t("content.actpawn4") }}
                          :
                          {{ formatNumberDecimalString(workcaseDetail.diffValue) }}
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold">{{ $t("content.amnanalysval") }} :
                          {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                        </td>
                        <td class="fs-14 text-bold">{{ $t("content.amnmaxvalall") }} :
                          {{ formatNumberDecimalString(workcaseDetail.ticket.totalFullValue) }}
                        </td>
                      </tr>
                      <tr v-else>
                        <td class="fs-14 text-bold" colspan="2">{{ $t("content.amnanalysval") }} :
                          {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }}
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold">{{ $t("content.statusticketlost") }} :
                          <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> ไม่มี
                          </span>
                          <span v-else style="color:red;">
                            มี ({{ workcaseDetail.lostCount }})
                          </span>
                        </td>
                        <td class="fs-14 text-bold">{{ $t("content.refnolost") }} :
                          <span v-if="workcaseDetail.lostCount === 0" style="color:green;"> -
                          </span>
                          <span v-else style="color:red;">
                            {{ workcaseDetail.lostRefNumber }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="workcaseDetail.represent || workcaseDetail.shopRepresent && !fcusdt">
                        <td class="fs-14 text-bold" colspan="2"> {{ $t("content.represent") }} :
                          <span style="color:red;">
                            {{workcaseDetail.customerInfo.name}}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="workcaseDetail.changeName && !fcusdt">
                        <td class="fs-14 text-bold" colspan="2"> {{ $t("content.changeName") }} ({{ bfChangename }}) :
                          <span style="color:red;">
                            {{ afChangename }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold" colspan="2"> {{ $t("content.transoutage") }} :
                          <span v-if="workcaseDetail.outage" style="color:red">
                            {{ $t("content.yes") }}
                          </span>
                          <span v-else style="color:green">
                            {{ $t("content.no") }}
                          </span>
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold" colspan="2"> {{ $t("content.amnlocationasset") }} :
                          <span v-if="workcaseDetail.ticket.locationName !== null">
                            {{ workcaseDetail.ticket.locationName }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold" colspan="2"> {{ $t("content.stockno") }} :
                          <span v-if="workcaseDetail.ticket.stockNumber !== null">
                            {{ workcaseDetail.ticket.stockNumber }}
                          </span>
                          <span v-else>
                            -
                          </span>

                        </td>
                      </tr>
                      <tr v-if="!fcusdt">
                        <td class="fs-14 text-bold" colspan="2"> {{ $t("content.migraref") }} :
                          <span v-if="workcaseDetail.migrateRefNumber !== null && workcaseDetail.migrateRefNumber !== ''">
                            {{ workcaseDetail.migrateRefNumber }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <span v-if="!fcusdt">
                    <span v-if="listinfo.length !== 0">
                      <table class="table table-sm table-borderless" 
                            style="width: 100%; table-layout: fixed; border-collapse: collapse; border: 0 !important;">
                        
                        <colgroup>
                          <col style="width: auto;">
                          <col style="width: 160px;"> <!-- ปรับตามความยาวตัวเลข -->
                        </colgroup>

                        <!-- เพิ่ม style ลบ border ที่ tbody เพื่อความชัวร์ -->
                        <tbody style="border: 0 !important;">
                          <tr>
                            <!-- ลบ border-top แบบเจาะจงที่ตัว td หัวข้อ -->
                            <td colspan="2" class="fs-14 text-bold" 
                                style="border: 0 !important; border-top: 0 !important; padding-top: 15px;">
                              <span style="text-decoration:underline;">
                                {{ $t("content.amnassetdetail") }}
                              </span>
                            </td>
                          </tr>

                          <tr v-for="(row, index) in listinfo" :key="index">
                            <td class="fs-14 text-bold" 
                                style="word-break: break-word; white-space: normal; vertical-align: top; text-align: left; padding-right: 5px; border: 0 !important;">
                              {{ formatNumberString(index + 1) }}. {{ row.remark }}
                            </td>
                            <td class="fs-12 text-bold" 
                                style="vertical-align: top; text-align: right; white-space: nowrap; border: 0 !important;">
                              <span style="color:blue;">
                                {{ formatNumberDecimalString(row.newPawnValue) }} 
                              </span> / {{ formatNumberDecimalString(row.fullValue) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </span>
                    <span v-else>
                      <tr>
                        <td class="fs-14 text-bold">
                          <span style="text-decoration:underline;">
                            {{ $t("content.amnassetdetail") }}
                          </span>
                          : -
                        </td>
                      </tr>
                    </span>
                  </span>
                  <span v-else>
                    <table class="table table-sm table-borderless" v-if="workcaseDetail.latest">
                      <tbody>
                        <tr>
                          <td class="fs-14 text-bold">
                            <span style="text-decoration:underline;">
                              {{ $t("content.amngrandtotal") }}
                            </span> :
                            {{ formatNumberDecimalString(workcaseDetail.newPawnValue) }} + {{
                              formatNumberDecimalString(intCal) }} =
                            <span style="color:blue;">
                              {{ formatNumberDecimalString(Number(workcaseDetail.newPawnValue) +
                                Number(intCal))
                              }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </span>
                </div>
                </div>
            </div>
          </div>

          <!-- ส่วนล่าง: ข้อมูลรายการชำระ -->
          <hr v-if="paymentE !== ''" />
          <div class="col-12 mt-2" v-if="paymentE !== ''">
            <div class="fs-14 text-bold">
              <span style="text-decoration:underline;">
                {{ $t("content.amnfinanceinfo") }}
              </span>
            </div>
            <pre></pre>
            <div class="row">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>{{ $t("content.ticketno") }}</th>
                      <th>{{ $t("content.amnbiz") }}</th>
                      <th colspan="5" class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          {{ $t("content.amnincome") }}
                        </span>
                      </th>
                      <th colspan="4" class="align-top text-center" style="background-color:#fecac7;">
                        <span style="color:black;">
                          {{ $t("content.amnoutcome") }}
                        </span>
                      </th>
                      <th colspan="4" class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          {{ $t("content.fee") }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th colspan="3"></th>
                      <th class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          {{ $t("content.amncash") }}
                        </span>
                      </th>
                      <th colspan="2" class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          {{ $t("content.amnbanktransfer") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          {{ $t("content.amncreditcard") }}
                        </span>

                      </th>
                      <th class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          {{ $t("content.amncheque") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#fecac7;">
                        <span style="color:black;">
                          {{ $t("content.amncash") }}
                        </span>
                      </th>
                      <th colspan="3" class="align-top text-center" style="background-color:#fecac7;">
                        <span style="color:black;">
                          {{ $t("content.amnbanktransfer") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          {{ $t("content.amncash") }}
                        </span>
                      </th>
                      <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          {{ $t("content.amnbanktransfer") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          {{ $t("content.amncreditcard") }}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <th colspan="3"></th>
                      <th style="background-color:#dfffdd;"></th>
                      <th class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          {{ $t("content.amnbankacc") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#dfffdd;">
                        <span style="color:black;">
                          QR Code
                        </span>
                      </th>
                      <th colspan="2" style="background-color:#dfffdd;"></th>
                      <th style="background-color:#fecac7;"></th>
                      <th class="align-top text-center" style="background-color:#fecac7;">
                        <span style="color:black;">
                          {{ $t("content.amnbankacc") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#fecac7;">
                        <span style="color:black;">
                          {{ $t("content.amntransfer_promt_mobile") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#fecac7;">
                        <span style="color:black;">
                          {{ $t("content.amntransfer_promt_taxid") }}
                        </span>
                      </th>
                      <th style="background-color:#CFEBFD;"></th>
                      <th class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          {{ $t("content.amnbankacc") }}
                        </span>
                      </th>
                      <th class="align-top text-center" style="background-color:#CFEBFD;">
                        <span style="color:black;">
                          QR Code
                        </span>
                      </th>
                      <th style="background-color:#CFEBFD;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in paymentE.workCases" :key="index">
                      <template v-if="row.ticket !== null">
                        <td class="text-sm font-weight-normal text-center">{{ formatNumberString(index + 1) }}
                        </td>
                        <td class="text-sm font-weight-normal text-center">{{ row.tkRefNumber }}</td>
                        <td class="text-sm font-weight-normal text-center">{{
                          checkTransaction(row.transactionType) }}</td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[0].receive > 0" style="color:green;">
                            {{ formatNumberDecimalString(paymentL[0].receive) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[1].receive > 0" style="color:green;">
                            {{ formatNumberDecimalString(paymentL[1].receive) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[6].receive > 0" style="color:green;">
                            {{ formatNumberDecimalString(paymentL[6].receive) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[2].receive > 0" style="color:green;">
                            {{ formatNumberDecimalString(paymentL[2].receive) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[3].receive > 0" style="color:green;">
                            {{ formatNumberDecimalString(paymentL[3].receive) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[0].pay > 0" style="color:red;">
                            {{ formatNumberDecimalString(paymentL[0].pay) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[1].pay > 0" style="color:red;">
                            {{ formatNumberDecimalString(paymentL[1].pay) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[4].pay > 0" style="color:red;">
                            {{ formatNumberDecimalString(paymentL[4].pay) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[5].pay > 0" style="color:red;">
                            {{ formatNumberDecimalString(paymentL[5].pay) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[0].fee > 0" style="color:blue;">
                            {{ formatNumberDecimalString(paymentL[0].fee) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[1].fee > 0" style="color:blue;">
                            {{ formatNumberDecimalString(paymentL[1].fee) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[6].fee > 0" style="color:blue;">
                            {{ formatNumberDecimalString(paymentL[6].fee) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                          :rowspan="paymentE.workCases.length">
                          <span v-if="paymentL[2].fee > 0" style="color:blue;">
                            {{ formatNumberDecimalString(paymentL[2].fee) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.fs-9 { font-size: 9px; }
.fs-10 { font-size: 10px; }
.fs-12 { font-size: 12px; }
.fs-13 { font-size: 13.5px; }
.fs-14 { font-size: 14.5px; }
.cursor-pointer { cursor: pointer; }

/* จัดการ Modal Header */
.modal-title { color: #444; }
.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}
/* คลาสช่วยจัดระเบียบ */
.align-middle { vertical-align: middle !important; }
</style>
